import React from "react";
import styled from "styled-components/macro";
import StatusUpdateSection from "../../components/StatusUpdateSection";
import { formatDateTime } from "../../utils/textUtils";

function GenericStatusUpdate({ statusUpdate }) {
  if (!statusUpdate) return null;

  const statusUpdateSections = statusUpdate.sections.map((section, index) => {
    return (
      <StatusUpdateSection
        key={index}
        title={section.title}
        descriptions={section.descriptions}
        description_blocks={section.description_blocks}
        status={section.status}
      />
    );
  });

  return (
    <>
      <StatusUpdateInfo>Most recent update {formatDateTime(statusUpdate.last_updated)}</StatusUpdateInfo>
      {statusUpdateSections}
    </>
  );
}

export default GenericStatusUpdate;

const StatusUpdateInfo = styled.div`
  color: var(--juno-color-text-secondary);
  line-height: 1.5;
  margin-bottom: var(--juno-space-4);
`;
